/**
 * Invoice UI types — backend statuses are mapped to these labels by adapter.
 */

export type InvoiceStatus = 'Paid' | 'Partial' | 'Overdue' | 'Draft';

export interface Invoice {
  invoiceNumber: string;
  customer: string;
  orderNumber: string;
  issueDate: string;
  dueDate: string;
  dueDateOverdue: boolean;
  amount: string;
  balance: string;
  status: InvoiceStatus;
  // Original backend ids — used by row actions (View, etc.)
  id: number;
  orderId: number;
}

export const statusStyles: Record<InvoiceStatus, { bg: string; color: string; border: string }> = {
  Paid:    { bg: '#F0FDF4', color: '#16A34A', border: '#BBF7D0' },
  Partial: { bg: '#FFF7ED', color: '#EA580C', border: '#FED7AA' },
  Overdue: { bg: '#FEF2F2', color: '#DC2626', border: '#FECACA' },
  Draft:   { bg: '#F3F4F6', color: '#6B7280', border: '#E5E7EB' },
};

export const STATUS_OPTIONS = ['All Statuses', 'Paid', 'Partial', 'Overdue', 'Draft'] as const;

/**
 * Maps the backend `InvoiceStatus` (draft|sent|paid|overdue|cancelled)
 * to the UI label this page renders. 'sent' maps to 'Draft' to fit
 * the four-bucket model the existing badge supports.
 */
export function backendStatusToUi(status: string): InvoiceStatus {
  switch (status) {
    case 'paid':
      return 'Paid';
    case 'overdue':
      return 'Overdue';
    case 'sent':
      return 'Partial';
    case 'cancelled':
    case 'draft':
    default:
      return 'Draft';
  }
}
